import { useParams } from 'react-router-dom';

import { AppLookAndFeelSettingsPage } from '~/components/pages/AppLookAndFeelSettingsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppLookAndFeelSettingsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppLookAndFeelSettingsPage appId={appId} />
    </DashboardTemplate>
  );
};
